/* eslint-disable @typescript-eslint/no-explicit-any */

import { memo, useState } from 'react';
import Paper from '@mui/material/Paper';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import CloudDownload from '@mui/icons-material/CloudDownload';
import cx from 'classnames';

import { IAudioPlayerColors } from '../types';

// Styles removed - TODO: migrate to sx props

interface IAudioDownloadsControl {
    src: string | string[];
    playerColors: IAudioPlayerColors;
    classNames?: any;
}

export const AudioDownloadsControl: React.FunctionComponent<IAudioDownloadsControl> = ({
    src,
    classNames = {},
}) => {
    // const classes = useComponentStyles({ playerColors });
    const [downloadsDropdownOpened, openDownloadsDropdown] = useState(false);
    const theme: { [key: string]: any } = useTheme();
    const toggleDownloadsDropdown = (value: boolean) => () => {
        openDownloadsDropdown(value);
    };
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return Array.isArray(src) ? (
        isMobile ? (
            <Grid>
                <a href={src[0]} download={true}>
                    <CloudDownload fontSize="large" />
                </a>
            </Grid>
        ) : (
            <Grid
                onMouseEnter={toggleDownloadsDropdown(true)}
                onMouseLeave={toggleDownloadsDropdown(false)}
            >
                <CloudDownload fontSize="large" />
                {downloadsDropdownOpened && (
                    <Stack
                        component={Paper}
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {src.map((srcLink, index) => {
                            return (
                                <Box key={index} className={cx(classNames.downloadsContainer)}>
                                    <a
                                        className={cx(classNames.downloadsItemLink)}
                                        href={srcLink}
                                        download={true}
                                    >
                                        <Typography color="textPrimary">
                                            {srcLink
                                                .substring(srcLink.lastIndexOf('.') + 1)
                                                .toUpperCase()}
                                        </Typography>
                                    </a>
                                </Box>
                            );
                        })}
                    </Stack>
                )}
            </Grid>
        )
    ) : (
        <Grid>
            <a href={src} download={true}>
                <CloudDownload fontSize="large" />
            </a>
        </Grid>
    );
};

export default memo(AudioDownloadsControl);
